import { rankingData } from '@/mocks/homeData';

const badgeColors: Record<string, string> = {
  HOT: 'bg-primary-500',
  NEW: 'bg-accent-500',
  UP: 'bg-secondary-500',
  RI: 'bg-primary-400',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <span className="text-xs font-semibold text-primary-500 uppercase tracking-wider">🔥 HOT RANKING</span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-2">热门排行</h2>
            <p className="text-sm text-foreground-500 mt-1">全网漫画热度实时排行，发现大家都在追的漫画</p>
          </div>
          <div className="hidden sm:flex items-center gap-2">
            <button className="px-4 py-2 text-sm font-medium bg-primary-500 text-background-50 rounded-full cursor-pointer whitespace-nowrap border-0">热度榜</button>
            <button className="px-4 py-2 text-sm font-medium text-foreground-600 bg-background-50 rounded-full cursor-pointer whitespace-nowrap border-0 hover:bg-background-200 transition-colors">更新榜</button>
            <button className="px-4 py-2 text-sm font-medium text-foreground-600 bg-background-50 rounded-full cursor-pointer whitespace-nowrap border-0 hover:bg-background-200 transition-colors">讨论榜</button>
          </div>
        </div>

        <div className="flex flex-col gap-3">
          {rankingData.map((item) => (
            <a
              key={item.rank}
              href="#"
              className="flex items-center gap-4 p-4 bg-background-50 rounded-xl hover:bg-background-100 transition-colors duration-200 cursor-pointer no-underline group"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-bold text-sm flex-shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="w-12 h-16 flex-shrink-0 rounded-md overflow-hidden bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                    {item.title}
                  </h3>
                  <span className={`px-1.5 py-0.5 text-[10px] font-bold text-background-50 rounded ${badgeColors[item.badge] || 'bg-primary-500'} flex-shrink-0`}>
                    {item.badge}
                  </span>
                </div>
                <p className="text-xs text-foreground-500">{item.author} · {item.genre}</p>
              </div>

              <div className="hidden sm:flex items-center gap-3 flex-shrink-0">
                <span className="text-xs text-foreground-400">
                  <i className="ri-eye-line mr-1"></i>{item.views}
                </span>
              </div>

              <div className="flex-shrink-0">
                <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}